import {UpmPlant, useUpmPlantsContext} from '@hconnect/upm'

import {useSuiteHierarchyId} from './useSuiteHierarchyId'

/**
 * Custom hook that extracts hierarchyId from Suite URL path params
 * and maps it to a legacy plantId using UPM plants context.
 *
 * Used in Suite application where hierarchy IDs (upmId) are used in URLs
 * but legacy plantIds are required by the SLA Tracking feature.
 *
 * URL pattern: /:featureName/hierarchyId/:hierarchyId/*
 *
 * @returns plantId - Legacy plant identifier
 * @throws Error if hierarchyId is not provided in URL
 * @throws Error if no plant is found for the given hierarchyId
 */
export const usePlantIdFromHierarchyId = (): string | null => {
  const upmPlant = usePlantFromHierarchyId()

  if (!upmPlant) {
    return null
  }

  return upmPlant.plantId
}

export const usePlantFromHierarchyId = (): UpmPlant | null => {
  const hierarchyId = useSuiteHierarchyId()

  if (!hierarchyId) {
    throw new Error('No hierarchyId param provided in URL path.')
  }

  const plantsMap = useUpmPlantsContext({isInitialLoad: true})

  if (!plantsMap) {
    return null
  }

  const upmPlant = Object.values(plantsMap).find((p) => p.upmId === hierarchyId)

  if (!upmPlant) {
    throw new Error(`No plant found for hierarchyId: ${hierarchyId}`)
  }

  return upmPlant
}
